<button type="button" class="onb-ajuda-botao" (click)="abra()" aria-label="Ajuda">
  <i class="far fa-question-circle"></i><span>Ajuda</span>
</button>

<div class="onb-ajuda-veu" *ngIf="aberto" (click)="feche()">
  <aside class="onb-ajuda-folha" role="dialog" aria-label="Ajuda" (click)="$event.stopPropagation()">
    <div class="onb-ajuda-topo">
      <div><span>Ajuda</span><b>{{ nomePasso }}</b></div>
      <button type="button" (click)="feche()" aria-label="Fechar"><i class="fas fa-times"></i></button>
    </div>

    <div class="onb-ajuda-bloco" *ngIf="temVideo">
      <app-onb-video [passo]="passoDaAjuda"></app-onb-video>
    </div>

    <div class="onb-ajuda-bloco onb-ajuda-mia" *ngIf="linkWhatsapp">
      <div class="onb-ajuda-mia-cab">
        <span class="onb-ajuda-av">M</span>
        <div><b>Falar com a Mia no WhatsApp</b><span>A mesma conversa em que você criou a loja. Se precisar, ela chama uma pessoa da equipe.</span></div>
      </div>
      <pre class="onb-ajuda-msg">{{ mensagem }}</pre>
      <a class="onb-btn onb-btn--pri onb-btn--grande" [href]="linkWhatsapp" target="_blank" rel="noopener" (click)="abriuWhatsapp()">
        <i class="fab fa-whatsapp"></i> Abrir WhatsApp com essa mensagem
      </a>
    </div>

    <div class="onb-ajuda-bloco">
      <b class="onb-ajuda-rot">Dúvidas comuns aqui</b>
      <div class="onb-ajuda-duvidas">
        <div class="onb-ajuda-duvida" *ngFor="let d of duvidas; let i = index">
          <button type="button" (click)="alterneDuvida(i)" [attr.aria-expanded]="duvidaAberta === i">
            <span>{{ d.pergunta }}</span><i class="fas" [class.fa-chevron-down]="duvidaAberta !== i" [class.fa-chevron-up]="duvidaAberta === i"></i>
          </button>
          <p *ngIf="duvidaAberta === i">{{ d.resposta }}</p>
        </div>
      </div>
    </div>
  </aside>
</div>
